import { useCallback } from 'react'

const INTERSTITIAL_HTML = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <title>Finding BRP Financial Services offers...</title>
  <style>
    body {
      margin: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
      font-family: sans-serif;
      background: #fff;
      gap: 24px;
    }
    .spinner {
      width: 40px;
      height: 40px;
      border: 4px solid #e0e0e0;
      border-top-color: #333;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
    }
    @keyframes spin { to { transform: rotate(360deg); } }
    p {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #1a1a1a;
    }
  </style>
</head>
<body>
  <div class="spinner"></div>
  <p>Finding your BRP Financial Services offers...</p>
</body>
</html>`

export default function usePortalJump(
    hasCopy: boolean,
    triggerCopy: () => Promise<string | null>,
): () => Promise<void> {
    return useCallback(async () => {
        // pi-lens-ignore: ast-grep:no-open-redirect
        const newTab = window.open('about:blank', '_blank')

        if (!newTab) {
            return
        }

        if (!hasCopy) {
            newTab.document.write(INTERSTITIAL_HTML)
        }

        const url = await triggerCopy()

        if (!url) {
            newTab.close()

            return
        }

        try {
            const parsed = new URL(url)

            if (parsed.protocol !== 'https:') {
                newTab.close()

                return
            }

            newTab.location.href = parsed.toString()
        } catch {
            newTab.close()
        }
    }, [hasCopy, triggerCopy])
}
